export const buildOptOutLinks = (fields = {}) => {
  const allOptOutLinks = [fields.OptOutLinkOne?.value, fields.OptOutLinkTwo?.value, fields.OptOutLinkThree?.value, fields.OptOutLinkFour?.value, fields.OptOutLinkFive?.value, fields.OptOutLinkSix?.value, fields.OptOutLinkSeven?.value, fields.OptOutLinkEight?.value, fields.OptOutLinkNine?.value, fields.OptOutLinkTen?.value];
  const populatedOptOutLinks = [];
  for (let i = 0; i < allOptOutLinks.length; i += 1) {
    const linkText = allOptOutLinks[i]?.text;
    const linkHref = allOptOutLinks[i]?.href;
    const isHrefValid = allOptOutLinks[i]?.href !== "http://"; // If user adds link text but no url then Sitecore creates the item with a href of "http://" so we should consider these as invalid hrefs.

    if (linkText && linkHref && isHrefValid) {
      populatedOptOutLinks.push({
        name: linkText,
        optOutLink: linkHref
      });
    }
  }
  return populatedOptOutLinks;
};